import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  user: null,
  signupuser: null,
  forgetpass: null,
  isAuthenticated: false,
  routeType: null,
  loading: false,
  exportLoading: false,
  logiCheckAdmin: null,
  logiCheckloading: false,
  twoFASetupAdmin: null,
  twoFASetuploading: false,
  twoFASetupVerifyAdmin: null,
  twoFASetupVerifyloading: false,
  forgotPasswordAdmin: null,
  forgotPasswordloading: false,
  verifyOTPAdmin: null,
  verifyOTPloading: false,
  resetPasswordAdmin: null,
  resetPasswordloading: false,
  detailsLoading : false,
  admin : null
};

const slice = createSlice({
  name: "auth",
  initialState: { ...initialState },
  reducers: {
    logoutUser: (state, action) => {
      return { ...initialState, user: null };
    },
    setRouteType: (state, action) => {
      state.routeType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Act.loginCheck.pending, (state, action) => {
      state.logiCheckloading = true;
    });
    builder.addCase(Act.loginCheck.fulfilled, (state, action) => {
      state.logiCheckAdmin = action.payload;
      state.logiCheckloading = false;
    });
    builder.addCase(Act.loginCheck.rejected, (state, action) => {
      state.logiCheckAdmin = initialState.user;
      state.logiCheckloading = false;
    });

    builder.addCase(Act.twoFASetup.pending, (state, action) => {
      state.twoFASetuploading = true;
    });
    builder.addCase(Act.twoFASetup.fulfilled, (state, action) => {
      state.twoFASetupAdmin = action.payload;
      state.twoFASetuploading = false;
    });
    builder.addCase(Act.twoFASetup.rejected, (state, action) => {
      state.twoFASetupAdmin = initialState.user;
      state.twoFASetuploading = false;
    });

    builder.addCase(Act.twoFASetupVerify.pending, (state, action) => {
      state.twoFASetupVerifyloading = true;
    });
    builder.addCase(Act.twoFASetupVerify.fulfilled, (state, action) => {
      state.twoFASetupVerifyAdmin = action.payload;
      state.twoFASetupVerifyloading = false;
    });
    builder.addCase(Act.twoFASetupVerify.rejected, (state, action) => {
      state.twoFASetupVerifyAdmin = initialState.user;
      state.twoFASetupVerifyloading = false;
    });

    builder.addCase(Act.loginUser.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.loginUser.fulfilled, (state, action) => {
      state.user = action.payload;
      state.loading = false;
    });
    builder.addCase(Act.loginUser.rejected, (state, action) => {
      state.user = initialState.user;
      state.loading = false;
    });

    builder.addCase(Act.updateAdmin.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.updateAdmin.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload?.role === "ADMIN") {
        state.user = action.payload;
      }
    });
    builder.addCase(Act.updateAdmin.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(Act.viewUser.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.viewUser.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload;
    });
    builder.addCase(Act.viewUser.rejected, (state, action) => {
      state.loading = false;
      state.user = null;
    });

    builder.addCase(Act.detailsAdmin.pending, (state, action) => {
      state.detailsLoading = true;
    });
    builder.addCase(Act.detailsAdmin.fulfilled, (state, action) => {
      state.detailsLoading = false;
      state.admin = action.payload;
    });
    builder.addCase(Act.detailsAdmin.rejected, (state, action) => {
      state.detailsLoading = false;
      state.admin = null;
    });

    builder.addCase(Act.forgotPassword.pending, (state, action) => {
      state.forgotPasswordloading = true;
    });
    builder.addCase(Act.forgotPassword.fulfilled, (state, action) => {
      state.forgotPasswordAdmin = action.payload;
      state.forgotPasswordloading = false;
    });
    builder.addCase(Act.forgotPassword.rejected, (state, action) => {
      state.forgotPasswordAdmin = initialState.user;
      state.forgotPasswordloading = false;
    });

    builder.addCase(Act.verifyOTP.pending, (state, action) => {
      state.verifyOTPloading = true;
    });
    builder.addCase(Act.verifyOTP.fulfilled, (state, action) => {
      state.verifyOTPAdmin = action.payload;
      state.verifyOTPloading = false;
    });
    builder.addCase(Act.verifyOTP.rejected, (state, action) => {
      state.verifyOTPAdmin = initialState.user;
      state.verifyOTPloading = false;
    });

    builder.addCase(Act.resetPassword.pending, (state, action) => {
      state.resetPasswordloading = true;
    });
    builder.addCase(Act.resetPassword.fulfilled, (state, action) => {
      state.resetPasswordAdmin = action.payload;
      state.resetPasswordloading = false;
    });
    builder.addCase(Act.resetPassword.rejected, (state, action) => {
      state.resetPasswordAdmin = initialState.user;
      state.resetPasswordloading = false;
    });

    builder.addCase(Act.uploadFile.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.uploadFile.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.uploadFile.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.getCsrfToken.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.getCsrfToken.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.getCsrfToken.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(Act.userSessionLogout.pending, (state, action) => {
      state.logoutLoading = true;
    });
    builder.addCase(Act.userSessionLogout.fulfilled, (state, action) => {
      state.logoutLoading = false;
      state.user = null;
    });
    builder.addCase(Act.userSessionLogout.rejected, (state, action) => {
      state.logoutLoading = false;
    });
    builder.addCase(Act.changePassword.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(Act.changePassword.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.changePassword.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.exportUsersList.pending, (state, action) => {
      state.exportLoading = true;
    });
    builder.addCase(Act.exportUsersList.fulfilled, (state, action) => {
      state.exportLoading = false;
    });
    builder.addCase(Act.exportUsersList.rejected, (state, action) => {
      state.exportLoading = false;
    });
  },
});

export default slice;
